import { render, staticRenderFns } from "./SectionNotForPhone.vue?vue&type=template&id=33eaf368"
import script from "./SectionNotForPhone.vue?vue&type=script&lang=js"
export * from "./SectionNotForPhone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports